import { useEffect } from "react";
import { useToast } from "../contexts/ToastContext";
import { onRareEffort } from "../utils/badgeBus";

/**
 * Says a just-saved session's rare effort out loud ("Best 2 km this year:
 * 7:41.8", api/lib/rareEffort.js), once, as the save finishes.
 */
export function useRareEffortNotice() {
  const { showToast } = useToast();
  useEffect(() => onRareEffort((effort) => showToast({ title: effort.text, duration: 8000 })), [showToast]);
}
